
        import 'CompanyTypeahead.fb56616.css-module'
        export default {"CompanyTypeahead":"CompanyTypeahead_CompanyTypeahead_fb56616","SuggestionsList":"SuggestionsList_CompanyTypeahead_fb56616","SuggestionsItem":"SuggestionsItem_CompanyTypeahead_fb56616","selectedSuggestions":"selectedSuggestions_CompanyTypeahead_fb56616"}
    